@let isDesktop = deviceService.isDesktop$ | async;
@let user = currentUser$ | async;
@let isLoading = isLoading$ | async;
@let changePasswordBlockVisible = $changePasswordBlockVisible();

<div
  class="x-card x-card_size_m rounded-t-none block box-border"
  [ngClass]="{
    'bg-inherit': !isDesktop,
    'bg-(--tui-background-base-alt) desktop-width-limit mx-auto island-without-top-border':
      isDesktop,
  }"
>
  <div
    class="x-card x-card_size_m box-border w-full"
    [tuiSkeleton]="!!isLoading"
    [ngClass]="{
      'h-[calc(100vh-var(--x-desktop-header-height)-2rem)] desktop-width-limit mx-auto island-without-top-border bg-(--tui-background-base-alt)':
        isDesktop,
      'h-[calc(100vh-var(--x-mobile-header-height)-2rem)] bg-(--tui-background-base-alt)':
        !isDesktop,
    }"
  >
    <h1
      [ngClass]="{
        'text-[28px]/[24px] font-extrabold': isDesktop,
        'x-font-body-1-bold': !isDesktop,
      }"
    >
      {{ 'profile_page.title' | translate }}
    </h1>

    <span
      [tuiAvatar]="user?.fullname || '' | tuiInitials"
      [round]="false"
      [style.background]="user?.fullname || '' | tuiAutoColor"
      size="xxl"
      class="mt-6 ms-5 w-[200px]! h-[200px]!"
    >
      @if (getAvatarUrl(user?.avatar); as avatarUrl) {
        <img alt="" [src]="avatarUrl" />
      }
    </span>

    <form
      class="mt-5 mx-2"
      [formGroup]="userForm"
      [ngClass]="{
        'w-2/5': isDesktop,
      }"
    >
      <div class="x-text-dark-main x-font-body-3-bold">
        {{ 'profile_page.email_label' | translate }}
      </div>
      <tui-textfield
        class="x-font-body-3 x-text-dark x-white input-without-shadow"
        [tuiTextfieldCleaner]="true"
        tuiTextfieldSize="m"
      >
        <input
          [formControlName]="FormFields.Email"
          [placeholder]="'profile_page.email_placeholder' | translate"
          tuiInput
          type="email"
        />
      </tui-textfield>
      <tui-error
        [formControlName]="FormFields.Email"
        class="absolute left-[30px] x-font-body-4-bold-important"
      ></tui-error>
      <div class="x-text-dark-main x-font-body-3-bold mt-5">
        {{ 'profile_page.full_name_label' | translate }}
      </div>
      <tui-textfield
        class="x-font-body-3 x-text-dark x-white input-without-shadow"
        [tuiTextfieldCleaner]="true"
        tuiTextfieldSize="m"
      >
        <input
          [formControlName]="FormFields.Fullname"
          tuiInput
          [readOnly]="true"
        />
      </tui-textfield>
    </form>
    <button
      tuiButton
      type="button"
      size="m"
      appearance="outline"
      class="mt-5 block! w-60 complete-button"
      (click)="toggleShowSetNewPasswordBlock()"
    >
      <span class="x-font-body-4-bold">
        {{
          changePasswordBlockVisible
            ? ('profile_page.cancel_change_password' | translate)
            : ('profile_page.change_password' | translate)
        }}
      </span>
    </button>
    <tui-expand [expanded]="changePasswordBlockVisible">
      <ng-container [ngTemplateOutlet]="changePasswordBlock" />
    </tui-expand>

    @if (!changePasswordBlockVisible) {
      <button
        tuiButton
        type="button"
        size="m"
        appearance="outline"
        class="mt-3 block! w-60 complete-button"
        [disabled]="userForm.invalid || userForm.pristine"
        (click)="updateProfile()"
      >
        <span class="x-font-body-4-bold">{{
          'profile_page.save_changes' | translate
        }}</span>
      </button>

      <button
        tuiButton
        type="button"
        size="m"
        appearance="outline"
        class="mt-3 block! w-60 complete-button"
        (click)="resetUserSettings()"
      >
        <span class="x-font-body-4-bold">{{
          'profile_page.reset_settings' | translate
        }}</span>
      </button>

      <button
        tuiButton
        type="button"
        size="m"
        appearance="outline"
        class="mt-3 block! w-60 complete-button"
        (click)="logout()"
      >
        <span class="x-font-body-4-bold">{{
          'profile_page.logout' | translate
        }}</span>
      </button>
    }
  </div>
</div>

<ng-template #changePasswordBlock>
  <form
    [formGroup]="changePasswordForm"
    class="mt-5 mx-2"
    [ngClass]="{
      'w-2/5': isDesktop,
    }"
  >
    <div class="x-text-dark-main x-font-body-3-bold mt-3">
      {{ 'profile_page.new_password_label' | translate }}
    </div>
    <tui-textfield
      class="x-font-body-3 x-text-dark x-white input-without-shadow"
      [tuiTextfieldCleaner]="true"
      tuiTextfieldSize="m"
    >
      <input
        [formControlName]="FormFields.NewPassword"
        tuiInput
        [readOnly]="true"
        [placeholder]="'profile_page.new_password_placeholder' | translate"
      />
    </tui-textfield>

    @if (newPasswordField.touched && newPasswordField.errors?.['minlength']) {
      <tui-error
        [error]="'profile_page.new_password_error_too_short' | translate"
        class="absolute left-[30px] x-font-body-4-bold-important"
      ></tui-error>
    } @else {
      <tui-error
        [formControlName]="FormFields.NewPassword"
        class="absolute left-[30px] x-font-body-4-bold-important"
      ></tui-error>
    }

    <div class="x-text-dark-main x-font-body-3-bold mt-5">
      {{ 'profile_page.confirm_new_password_label' | translate }}
    </div>
    <tui-textfield
      class="x-font-body-3 x-text-dark x-white input-without-shadow"
      [tuiTextfieldCleaner]="true"
      tuiTextfieldSize="m"
    >
      <input
        [formControlName]="FormFields.Confirmation"
        tuiInput
        [placeholder]="
          'profile_page.confirm_new_password_placeholder' | translate
        "
      />
    </tui-textfield>
    <tui-error
      [formControlName]="FormFields.Confirmation"
      class="absolute left-[30px] x-font-body-4-bold-important"
    ></tui-error>

    <div class="relative mt-12">
      @if (
        changePasswordForm.errors?.['passwordMismatch'] &&
        (changePasswordForm.dirty || changePasswordForm.touched)
      ) {
        <tui-error
          [error]="'profile_page.confirm_password_error_mismatch' | translate"
          class="absolute top-[-25px] left-[22px] x-font-body-4-bold-important"
        ></tui-error>
      }
      <button
        tuiButton
        type="button"
        size="m"
        appearance="outline"
        class="block! w-60 complete-button"
        [disabled]="changePasswordForm.invalid || changePasswordForm.pristine"
        (click)="setNewPassword()"
      >
        <span class="x-font-body-4-bold">{{
          'profile_page.set_new_password_button' | translate
        }}</span>
      </button>
    </div>
  </form>
</ng-template>
